document.addEventListener("DOMContentLoaded", loadMobProdImgScroll);

function loadMobProdImgScroll() {
  const carousel = document.querySelector('.product-page--root carousel-root transition-root');
  const windowWidth = () => window.innerWidth;

  if (carousel) {
    const mediaCarouselBoundingRect = () => carousel.getBoundingClientRect();
    const productMediaVariantsWidth = () => mediaCarouselBoundingRect().width;

    if (productMediaVariantsWidth() > windowWidth()) {
      const track = document.getElementById('image-scroll-track-mobile');
      const trackThumb = document.getElementById('image-scroll-thumb-mobile');

      let numberOfCards = carousel.querySelectorAll('.carousel--block').length;
      trackThumb.style.width = `${Math.round(100 / numberOfCards)}%`

      trackUpdate();

      carousel.addEventListener('transitionend', trackUpdate);
      carousel.addEventListener('touchstart', trackUpdate);
      carousel.addEventListener('resize', trackUpdate);

      function trackUpdate () {
        if (window.screen.width <= 767) {
          //element scroll calculation
          const transfromMatrix = window.getComputedStyle(carousel).transform;
          let translateX;
          if (transfromMatrix && transfromMatrix !== 'none') {
            // The matrix value is in the form 'matrix(a, b, c, d, tx, ty)'
            const matrix = transfromMatrix.match(/matrix\(([^)]+)\)/)[1].split(', ');
            translateX = Math.abs(parseFloat(matrix[4])); // The fifth value represents translateX
          }
          const lastElementSize = carousel.querySelector('.carousel--block:last-of-type').getBoundingClientRect().width;
          const scrollMaximum = productMediaVariantsWidth() - lastElementSize;
          const percentageOfCarouselContainer = Math.round(translateX * 100 / scrollMaximum);

          //thumb track calculation
          const trackWidth = track.getBoundingClientRect().width;
          const thumbWidth = trackThumb.getBoundingClientRect().width;
          const trackMaximum = trackWidth - thumbWidth;

          const trackPercentageToPx = Math.round(trackMaximum * percentageOfCarouselContainer / 100);
          const isScrollWithinInterval = trackMaximum > trackPercentageToPx;

          trackThumb.style.left = isScrollWithinInterval ? `${trackPercentageToPx}px` : `${trackMaximum}px`;
        }
      }
    }
  }
}